<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
    <v-container fluid full-height grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="currencyList"
                  label="Select Currency"
                  v-model="currencyExchange.currencyId"
                  item-text="code"
                  item-value="id"
                  :rules="[ !!currencyExchange.currencyId || 'Currency is required']"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="exchangeRate"
                  label="Exchange Rate"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  v-model="currencyExchange.exchangeRate"
                  :rules="[ !!currencyExchange.exchangeRate || 'Rate is required']"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn type="submit" color="primary" :loading="saveLoading" :disabled="!valid">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { currencyExchangeRateService } from "../../services/currency-exchange-rate-service";
import { currencyService } from "../../services/currency-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { CurrencyExchangeRate } from "../../models/model";

export default {
  name: "CurrencyExchangeDetail",
  components: { VSwitch },
  data: () => ({
    breadcrumbs: [
      {
        text: "Currency Exchange",
        disabled: false,
        to: "currencies",
      },
      {
        text: "Currency Exchange Detail",
        disabled: true,
      },
    ],
    currencyList: [],
    currencyExchange: new CurrencyExchangeRate(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    valid: true,
  }),

  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new Currency
    }
    this.getCurrencyByStatus();
  },

  methods: {
    getCurrencyByStatus() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        currencyExchangeRateService
          .saveCurrencyExchangeRate(this.currencyExchange)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      this.currencyExchange = new CurrencyExchangeRate();
      this.responseError = "";
    },

    goBack() {
      this.$router.push("/currency-exchange-rates");
    },
  },
};
</script>

<style scoped>
</style>